import { FunctionComponent } from "react";
import ForecasterThumbnail from "rivals/components/pages/Futurecast/ForecasterThumbnail";
import { TOP_CENTER } from "rivals/components/shared/Ads/Benji/constants";
import E2E from "rivals/components/shared/Ads/E2E";
import AdWrapper from "rivals/components/shared/Ads/WithRedux/container";
import { FuturecastLogo } from "rivals/components/shared/Icons/FuturecastLogo";
import styles from "./ForecasterList.module.scss";
import strings from "./strings";
import { StateProps } from "./types";

const ForecasterList: FunctionComponent<StateProps> = ({ forecasters }) => {
  if (!forecasters) {
    return <div className={styles.noForecasters}>{strings.emptyState}</div>;
  }

  return (
    <div className={styles.forecasterList}>
      <AdWrapper
        ad={E2E}
        forceAdToFront
        location={TOP_CENTER}
        locationCount={1}
        slotNumber={1}
      />
      <div className={styles.forecastersContainer}>
        <div className={styles.forecastersHeader}>
          <FuturecastLogo height={35} variant="light" />
          <div className={styles.titleText}>{strings.forecasterTitle}</div>
        </div>
        <div className={styles.list}>
          {forecasters.map((forecaster, keyVal) => (
            <ForecasterThumbnail forecaster={forecaster} key={keyVal} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ForecasterList;
